// context
export const FLAG_GETTING_CONTEXT = 'FLAG_GETTING_CONTEXT';
export const GET_CONTEXT_SUCCEEDED = 'GET_CONTEXT_SUCCEEDED';
export const GET_CONTEXT_FAILED = 'GET_CONTEXT_FAILED';
